import Phaser from 'phaser';
import { setupCamera } from '../dpr.js';
import { AuthService } from '../services/AuthService.js';
import { ServerHealthService } from '../services/ServerHealthService.js';

export class OfflineScene extends Phaser.Scene {
  constructor() {
    super({ key: 'OfflineScene' });
  }

  create(): void {
    setupCamera(this, this.cameras.main, 'full');
    const W = 960;
    const H = 576;

    this.add.rectangle(W / 2, H / 2, W, H, 0x0a0806);

    this.add.text(W / 2, H / 2 - 60, '⚠', {
      fontSize: '64px',
      color: '#ff6644',
    }).setOrigin(0.5);

    this.add.text(W / 2, H / 2 + 20, 'Server Offline', {
      fontSize: '28px',
      color: '#ff6644',
      fontFamily: 'serif',
    }).setOrigin(0.5);

    const statusText = this.add.text(W / 2, H / 2 + 70, 'Trying to reconnect…', {
      fontSize: '16px',
      color: '#888888',
    }).setOrigin(0.5);

    // Animate the dots
    let dots = 0;
    this.time.addEvent({
      delay: 600,
      loop: true,
      callback: () => {
        dots = (dots + 1) % 4;
        statusText.setText('Trying to reconnect' + '.'.repeat(dots));
      },
    });

    // Resume monitoring and navigate back when server recovers
    ServerHealthService.getInstance().start({
      onOffline: () => { /* already offline */ },
      onOnline: () => this._onRecovered(),
    });
  }

  private _onRecovered(): void {
    ServerHealthService.getInstance().stop();
    const target = AuthService.getInstance().isLoggedIn() ? 'MenuScene' : 'LoginScene';
    this.scene.start(target);
  }
}
